import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const SETTLEMENT_WAS_SUFFICIENT = {
  YES: 'yes',
  NO: 'no',
} as const;

export const SETTLEMENT_WAS_SUFFICIENT_NAME = 'settlement_was_sufficient';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupSettlementWasSufficient: FC<Props> = ({
  name = SETTLEMENT_WAS_SUFFICIENT_NAME,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t('Czy środki od ubezpieczyciela wystarczyły na naprawę?')}
          </FormLabel>
          <FormControl>
            <RadioGroup {...field} layout={'horizontal'}>
              <RadioItem
                data-testid={`${name}-radio-group-${SETTLEMENT_WAS_SUFFICIENT.NO}`}
                value={SETTLEMENT_WAS_SUFFICIENT.NO}
                label={i18n.t('Nie')}
              />
              <RadioItem
                data-testid={`${name}-radio-group-${SETTLEMENT_WAS_SUFFICIENT.YES}`}
                value={SETTLEMENT_WAS_SUFFICIENT.YES}
                label={i18n.t('Tak')}
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
